<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">MECHANICS</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>

                    <v-layout>
                        <v-container>
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable ></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>
                    <br><br>
                    <v-spacer></v-spacer>

                    <v-layout>
                        <v-list-tile @click="tableTitle='Active Mechanics'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Active Mechanics</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="activeColor"><b>{{activeMechanicsCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile @click="tableTitle='In-active Mechanics'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>In-active Mechanics</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="disabledColor"><b>{{inactiveMechanicsCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                    </v-layout>
                </v-container>
            </v-parallax>

            <v-layout>
                <v-container>
                    <v-layout>
                        <v-flex xs12>
                            <h4 class="subheading font-weight-medium"> {{tableTitle}} </h4>
                        </v-flex>
                        <v-spacer></v-spacer>
                        
						<v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
							<v-text-field label="Select CSV file" v-model="filename" @click="pickFile"  prepend-icon="attach_file" clearable readonly></v-text-field>
                            <input type="file" style="display: none" id="attachment" ref="fileInput" accept=".csv" @change="onFileChange($event)">
						</v-flex>
                        
                        <v-flex xs2>
                            <v-btn color="blue-grey" v-model="uploadBtn" @click="extractContents()" class="white--text">
                                Upload
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </v-flex>

                        <v-flex xs2>
                            <v-btn color="red accent-4" dark @click="$router.push('branch-mechanic-new/')">NEW MECHANIC</v-btn>
                        </v-flex>
                    </v-layout>

                <v-flex xs12>
                    <v-data-table v-if="watchMechanics=='active'" :search="search" :headers="headers" :items="activeMechanics" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.name }}</td>
                            <td class="text-xs-left">{{ props.item.email }}</td>
                            <td class="justify-center">
                                <v-icon small @click="requestForChange(props.item)">edit</v-icon>
                            </td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Mechanics Available
                            </v-alert>
                        </template>

                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                    <v-data-table v-else-if="watchMechanics=='in-active'" :search="search" :headers="headers" :items="inactiveMechanics" class="elevation-1">
                        <template v-slot:items="props">
                           <td>{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.name }}</td>
                            <td class="text-xs-left">{{ props.item.email }}</td>
                            <td class="justify-center">
                                <v-icon small @click="requestForChange(props.item)">edit</v-icon>
                            </td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Mechanics Available
                            </v-alert>
                        </template>

                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
                </v-container>
            </v-layout>

            <v-layout row justify-center>
                <v-dialog v-model="dialog" persistent width="300">
                    <v-card color="primary">
                        <v-card-text class="subheading white--text"> {{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true" v-if="showProgress"
                                :size="70" :width="5" color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-snackbar v-model="snackbar" bottom right :color="snackbarColor">{{ snackbarMessage }} 
                    <v-btn dark small flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>

                <v-dialog v-model="editDialog" persistent max-width="600px">
                    <v-card>
                        <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="70">
                            <v-container>
                                <v-layout>
                                <h4 class="subheading font-weight-medium">UPDATE MECHANIC</h4>
                                </v-layout>
                            </v-container>
                        </v-parallax>

                        <v-container grid-list>
                            <v-container>
                                <v-layout row wrap>

                                <v-flex xs12>
                                    <v-text-field label="Name*"  prepend-icon="perm_identity" v-model='forChange.name' readonly></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-autocomplete v-model="forChange.branch" label="Branch*" :items="branches" persistent-hint prepend-icon="domain" hide-no-data clearable leave-absolute>
                                        <template v-slot:append-outer>
                                            <v-slide-x-reverse-transition mode="out-in">
                                            </v-slide-x-reverse-transition>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field label="Email*" prepend-icon="mail_outline" v-model='forChange.email' required></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-checkbox v-model="forChange.tag" label="Visible to Customer"></v-checkbox>
                                </v-flex>

                                <v-flex xs12>
                                    <v-radio-group v-model="forChange.status" :mandatory="false" row>
                                        <v-radio label="Active" color="success" value="Active"></v-radio>
                                        <v-radio label="In-Active" color="orange darken-4" value="In-Active"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                </v-layout>
                            </v-container>
                            <v-layout justify-center>
                                <v-btn dark color="red accent-4" @click="editDialog=false">Cancel</v-btn>
                                <v-btn dark color="blue darken-4" @click="updateMechanic(forChange)">Save</v-btn>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'
import Papa from "papaparse"
export default {
    data() {
        return {
            mechanics: [],
            activeMechanics: [],
            inactiveMechanics: [],
            headers: [
                { text: 'Branch', value: 'branch',  sortable: true  },
                { text: 'Name', align: 'left', sortable: false, value: 'name'},
                { text: 'Email', value: 'email',  sortable: false  },
                { text: 'Actions', sortable: false }
            ],
            uploadBtn: "",
            filename: "",
            search: "",
            forChange: {},
            editDialog: false,
            snackbar: false,
            snackbarColor: "",
            snackbarMessage: "",
            progressMessage: "",
            showProgress: false,
            dialog: false,
            tableTitle: "Active Mechanics",
            disabledColor: "grey",
            activeColor: "red",
            activeMechanicsCount: 0,
            inactiveMechanicsCount: 0,
            watchMechanics: "active",
            branches: [],
        }
    },

    computed : {
        ...mapGetters(["user"]),
    },

    mounted() {
        this.fetchMechanics()
        this.fetchBranches()
    },

    methods: {

        pickFile() {
            let self = this
            self.filename = ""
			self.$refs.fileInput.click()
        },

        onFileChange(e) {
            let self = this

            const files = e.target.files
            if(files[0] !== undefined) {
                self.filename = files[0].name
                if(self.filename.lastIndexOf(".") <= 0) {
                    return
                }
                const fr = new FileReader ()
                fr.readAsDataURL(files[0])
                fr.addEventListener("load", () => {
                    let fileUrl = fr.result
                    self.file = files[0]
                    let fileExists = true
                })
            } else {
                self.filename = ""
            }
        },

        extractContents(){
            let self = this
            let time = ["09:00AM", "09:30AM", "10:00AM", "10:30AM", "11:00AM", "11:30AM", "01:00PM", "01:30PM", "02:00PM", "02:30PM", "03:00PM", "03:30PM", "04:00PM"]
            if(self.filename == "") {
                self.snackbarMessage = "Please select a file"
                self.snackbarColor = "error"
                self.snackbar = true
            } else {
                self.dialog = true
                self.showProgress = true
                self.progressMessage = "Uploading Mechanics..."
                let entries = []
                Papa.parse(self.file, { 
                    worker: false,
                    header: true,
                    skipEmptyLines: true,

                    step: function(row) {
                        let parsedata = {
                            branch: row.data.branch,
                            name: row.data.name,
                            email: row.data.email,
                        }
                        entries.push(parsedata)
                    },

                    complete() {
                        self.filename = ""
                        let Process = 0

                        entries.forEach(function(data) {
                            db.collection("Mechanics"+self.$stage).doc(data.name).set({
                                branch: data.branch,
                                name: data.name,
                                email: data.email,
                                time: time,
                                status: "Active",
                            })
                            .then(function() {
                                Process ++
                                if(Process === entries.length) {
                                    self.dialog = false
                                    self.showProgress = false
                                    self.snackbarMessage = "Uploading Mechanics Complete"
                                    self.snackbarColor = "success"
                                    self.snackbar = true
                                    setTimeout(() => {
                                        window.location.reload()
                                    }, 1000)
                                }
                            })
                            .catch(function(error) {
                                console.error("Error writing document: ", error)
                            })
                        })
                    }
                })
            }
        },

        async fetchBranches() {
            let self = this
            self.branches = []
            
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        self.branches.push(`${doc.data().branchCode}_${doc.data().businessUnit}`)
                    })
                }).then(function(){
                    if (self.branches.length == 0) {
                        self.snackbarMessage = "Please setup Branch"
                        self.snackbarColor = "error"
                        self.snackbar = true
                    } else {
                        self.branches = _.sortBy(self.branches, o => o.cluster)
                    }
                }).catch(function(error) {
                    console.error("Error fetching document: ", error)
                    self.snackbarMessage = "Error fetching data" 
                    self.snackbarColor = "error"
                    self.snackbar= true
                })   
        },

        async fetchMechanics() {
            let self = this
            self.dialog = true
            self.progressMessage = "Loading Mechanics..."
            self.showProgress = true
            self.mechanics = []
            self.activeMechanics = []
            self.inactiveMechanics = []

            await db.collection("Mechanics"+self.$stage)
            .onSnapshot(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                   self.mechanics.push(doc.data())
                })

                self.mechanics.forEach(function(list){
                    if(list.status == "Active") {
                        self.activeMechanics.push(list)
                    }
                    self.activeMechanicsCount = self.activeMechanics.length
                })

                self.mechanics.forEach(function(list){
                    if(list.status == "In-Active") {
                        self.inactiveMechanics.push(list)
                    }
                    self.inactiveMechanicsCount = self.inactiveMechanics.length
                })

                self.dialog = false
                self.showProgress = false
            }) 
        },

        requestForChange(mechanic) {
            let self = this 
            db.collection("Mechanics"+self.$stage).doc(mechanic.name)
            .get().then(function(doc) {
                self.forChange = doc.data()
            }).then(function() {
                self.editDialog = true
            })
        },

        updateMechanic(mechanic) {
            let self = this
            self.dialog = true
            self.showProgress = true
            self.progressMessage = "Updating Mechanic"

            setTimeout(() => {
                db.collection("Mechanics"+self.$stage).doc(mechanic.name)
                .update({
                    branch: mechanic.branch,
                    email: mechanic.email,
                    status: mechanic.status,
                    tag: mechanic.tag
                })
                .then(function() {
                    self.editDialog = false
                    self.dialog = false
                    self.showProgress = false
                    self.snackbarColor = "success"
                    self.snackbarMessage = "Successfully Updated"
                    self.snackbar = true
                    self.fetchMechanics()
                })
            }, 1000)
        },
    },

    watch: {
        tableTitle(val) {
            if(this.tableTitle == "Active Mechanics"){
                this.activeColor = "red"
                this.disabledColor = "grey"
                this.watchMechanics = "active"
            } else if(this.tableTitle == "In-active Mechanics"){
                this.disabledColor = "red"
                this.activeColor = "grey"
                this.watchMechanics = "in-active"
            }
        },
    }

}
</script>

<style scoped>

</style>